import { render } from "./MenuIndividual.vue?vue&type=template&id=0a021112"
import script from "./MenuIndividual.vue?vue&type=script&lang=js"
export * from "./MenuIndividual.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__